import { render, staticRenderFns } from "./Allowance.vue?vue&type=template&id=0c4789fb&scoped=true&"
import script from "./Allowance.vue?vue&type=script&lang=js&"
export * from "./Allowance.vue?vue&type=script&lang=js&"
import style0 from "./Allowance.vue?vue&type=style&index=0&id=0c4789fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4789fb",
  null
  
)

export default component.exports